import React from 'react';

import { IDocumentMetadata } from '../../../../api/types';
import { AppToggle } from '../../../../clients/unleash/app-toggle-names';
import { WithFeatureFlag } from '../../../WithFeatureFlag/WithFeatureFlag';

import { SearchQuery } from './SearchQuery/SearchQuery';
import { LastUpdatedAt } from './LastUpdatedAt';

import styles from './TopBar.module.scss';

export interface ITopBarProps {
    documentMetadata: IDocumentMetadata | undefined;
    queries?: string[];
}

export const AnswerTopBar: React.FC<ITopBarProps> = ({ documentMetadata, queries }) => {
    const displayTopBar = !!documentMetadata?.updated_at || !!queries?.length;

    if (!displayTopBar) {
        return null;
    }

    return (
        <div className={styles.topBar}>
            <SearchQuery queries={queries} className={styles.searchQueriesWrapper} />
            <WithFeatureFlag featureFlag={AppToggle.HANDLE_LAST_UPDATED_AT}>
                <LastUpdatedAt updatedAt={documentMetadata?.updated_at} />
            </WithFeatureFlag>
        </div>
    );
};
